import { render, staticRenderFns } from "./MessagebarFooter.vue?vue&type=template&id=0b3a2141&scoped=true&"
import script from "./MessagebarFooter.vue?vue&type=script&lang=js&"
export * from "./MessagebarFooter.vue?vue&type=script&lang=js&"
import style0 from "./MessagebarFooter.vue?vue&type=style&index=0&id=0b3a2141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a2141",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VFooter,VForm,VIcon,VRow,VSpacer,VTextarea})
